import { Dialog, dialogClasses } from '@mui/material';
import React, { ReactNode, useContext } from 'react';
import { styled } from 'styled-components';

import { MobileModalHeader } from '../../../features/Layout/MobileModalHeader';
import { WindowSize, WindowSizeContext } from '../../../hooks/windowSizeHook';
import { HospitalLogo } from '../HospitalLogo';
import { CloseButtonContainer, ModalCloseButton } from '../ModalCloseButton';
import { Transition } from '../transition';

export const StyledDialog = styled(Dialog)`
  & .${dialogClasses.paper} {
    display: flex;
    align-items: center;
    width: 575px;
    height: 600px;
    background-color: transparent;
  }
`;

const EditBox = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  width: 575px;
  height: 600px;
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1;
  box-sizing: border-box;
  border: 1px solid #f2f2f2;
  border-radius: 14px;
`;

const MobileEditContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 44px 28px;
`;

interface EditModalProps {
  open: boolean;
  onClose: () => void;
  children?: ReactNode;
}
export const EditModal = (props: EditModalProps) => {
  const { open, onClose, children } = props;
  const windowSize = useContext(WindowSizeContext);

  return (
    <>
      {windowSize === WindowSize.MOBILE ? (
        <Dialog
          open={open}
          TransitionComponent={Transition}
          onClose={onClose}
          fullScreen>
          <MobileModalHeader onGoBack={onClose} />
          <MobileEditContent>{children}</MobileEditContent>
        </Dialog>
      ) : (
        <StyledDialog open={open} onClose={onClose}>
          <EditBox>
            <CloseButtonContainer>
              <ModalCloseButton onClick={onClose} />
            </CloseButtonContainer>
            <HospitalLogo />
            {children}
          </EditBox>
        </StyledDialog>
      )}
    </>
  );
};
